import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveAccountGuard } from '@epicuro-next/features/accounts-selector';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import { AuthGuard } from '@epicuro-next/platform/authentication';
import { UserTermsGuard } from '@epicuro-next/state/user-state';

import { privateRoutes, routes } from '../models/routes';

import { UrlResolverGuard } from './url-resolver.guard';

@Injectable()
export class NavigationRoutesService {
  constructor(private router: Router) {}

  public resetToSupportMultiSites() {
    this.router.resetConfig([
      {
        path: APP_TOP_LEVEL_PATH.siteSelector.custom,
        canLoad: [AuthGuard],
        canActivate: [UrlResolverGuard, ActiveAccountGuard, UserTermsGuard],
        children: [
          {
            path: ':siteId',
            children: privateRoutes,
          },
          {
            path: '',
            canLoad: [AuthGuard],
            canActivate: [ActiveAccountGuard, UrlResolverGuard, UserTermsGuard],
            loadChildren: () =>
              import('@epicuro-next/features/site-selector').then(
                (m) => m.FeaturesSiteSelectorModule,
              ),
          },
        ],
      },
      ...routes,
      {
        path: '**',
        redirectTo: `${APP_TOP_LEVEL_PATH.siteSelector.custom}`,
      },
    ]);
  }
}
